import Login from './views/login.svelte'
import Waitlist from './views/waitlist.svelte'

const routes = [
{
    name: '/',
    component: Waitlist,
},
{
    name: 'login',
    component: Login
}
]

export {routes}